
    
    let callcount = 0;
     function showzoompopup(slidindex)
     {
     document.getElementById('mobilezoompopup').style.display='block';
     document.getElementById('closezoompopup').style.display='block';
    document.querySelector('body').classList.add('hide-scrollbar');
      
       callcount++;
       console.log(callcount);
       if(callcount == 1){
       $('.slider-for').slick('refresh');
         $('.slider-nav').slick('refresh');
       }
       setTimeout(function(){
         
         let slidIndex = document.querySelector(`.sliderpd_${slidindex}`).getAttribute('data-slick-index')
         let slidIndexInt = parseInt(slidIndex);
         $('.slider-for').slick('slickGoTo', slidIndexInt);
         $('.slider-nav').slick('slickGoTo', slidIndexInt);
           
       },100);
                             }
     function closezoompopup(){ document.getElementById('mobilezoompopup').style.display='none';
                              document.getElementById('closezoompopup').style.display='none';
                              document.querySelector('body').classList.remove('hide-scrollbar');}
                              
   
    
    
   
     const container = document.querySelector('#mobilezoompopup');
                   
   let startY;
   let startX;
   let scrollLeft;
   let scrollTop;
   let isDown;
   
   container.addEventListener('mousedown',e => mouseIsDown(e));  
   container.addEventListener('mouseup',e => mouseUp(e))
   container.addEventListener('mouseleave',e=>mouseLeave(e));
   container.addEventListener('mousemove',e=>mouseMove(e));
   
   function mouseIsDown(e){
     isDown = true;
     startY = e.pageY - container.offsetTop;
     startX = e.pageX - container.offsetLeft;
     scrollLeft = container.scrollLeft;
     scrollTop = container.scrollTop; 
   }
   function mouseUp(e){
     isDown = false;
   }
   function mouseLeave(e){
     isDown = false;
   }
   function mouseMove(e){
     if(isDown){
       e.preventDefault();
       //Move vertcally
       const y = e.pageY - container.offsetTop;
       const walkY = y - startY;
       container.scrollTop = scrollTop - walkY;
   
       //Move Horizontally
       const x = e.pageX - container.offsetLeft;
       const walkX = x - startX;
       container.scrollLeft = scrollLeft - walkX;
   
     }
   }

